import { DELIVERY_OPTION } from '@cinch/oxd-containers/delivery-preference/src'
import { defaultValues } from '@cinch/oxd-containers/listing-filters/src'

import { Age, BodyTypes, Colours, Doors, EngineSize, FuelTypes, TransmissionTypes } from '.'

const getSourceData = (type: string) => {
  switch (type) {
    case 'fromAge':
    case 'toAge':
      return Age
    case 'bodyType':
      return BodyTypes
    case 'colour':
      return Colours
    case 'fuelType':
      return FuelTypes
    case 'transitionType':
      return TransmissionTypes
    case 'doors':
      return Doors
    case 'fromEngineSize':
    case 'toEngineSize':
      return EngineSize
    default:
      return []
  }
}

const getFormattedLocation = (searchParams: Partial<Cinch.SavedSearch>) => {
  const hasLocation = !!searchParams.latitude && !!searchParams.longitude && !!searchParams.location
  if (searchParams.deliveryOption === DELIVERY_OPTION.DELIVERY) {
    return 'Delivery'
  }
  if (!hasLocation) {
    return 'National'
  }

  return searchParams.distance
    ? `Within ${searchParams.distance} miles of ${searchParams.location}`
    : searchParams.location
}

export default getFormattedLocation

const getFormattedLabel = (type: string, value: number | string) => {
  const sourceData = getSourceData(type) as any[]
  const valueObject = sourceData.find((item) => item.value === value)

  return valueObject && valueObject.value !== defaultValues[type as keyof typeof defaultValues] ? valueObject.label : ''
}

const getFormattedLabels = (type: string, valuesAsString = '') => {
  const sourceData = getSourceData(type) as any[]
  const values = valuesAsString.split(',')
  const valueObjects = sourceData.filter(({ value }) => values.find((val) => val === value.toString()))

  return valueObjects.map((object) => object.label).reduce((acc, curr) => (acc ? `${acc}, ${curr}` : curr), '')
}

const getFormattedRange = (type: string, from: number | string, to: number | string) => {
  const fromValue = getFormattedLabel(`from${type.substr(0, 1).toUpperCase()}${type.substr(1)}`, from)
  const toValue = getFormattedLabel(`to${type.substr(0, 1).toUpperCase()}${type.substr(1)}`, to)

  if (!fromValue && !toValue) {
    return ''
  }
  if (fromValue && toValue) {
    return `${fromValue}-${toValue}`
  } else if (fromValue) {
    return `From ${fromValue}`
  } else {
    return `To ${toValue}`
  }
}

export { getFormattedLocation, getFormattedLabel, getFormattedLabels, getFormattedRange }
